import { useTheme } from "../context/ThemeContext";

const SOCIAL = [
  { label: "YouTube", href: "https://www.youtube.com/@Caffei_N", icon: "📺" },
  { label: "Facebook", href: "https://facebook.com/caffeiN0w0", icon: "👥" },
  { label: "Pinterest", href: "https://www.pinterest.com/caffei_n", icon: "📌" },
];

export default function AboutMe() {
  const { dark } = useTheme();

  return (
    <div
      className={`min-h-screen transition-colors duration-300 ${
        dark ? "bg-gray-900" : "bg-gradient-to-br from-stone-50 to-emerald-50"
      }`}
    >
      <div className="max-w-2xl mx-auto px-6 py-20">
        {/* Header */}
        <header className="text-center mb-14">
          <div className="text-6xl mb-5">🩺</div>
          <h1 className={`text-4xl font-bold mb-1 ${dark ? "text-white" : "text-gray-900"}`}>
            About Me
          </h1>
          <p className={`text-xl font-medium mt-1 ${dark ? "text-emerald-400" : "text-emerald-600"}`}>
            Mimion
          </p>
          <p className={`text-sm mt-2 ${dark ? "text-gray-500" : "text-gray-400"}`}>
            📍 Dhaka, Bangladesh
          </p>
        </header>

        {/* Bio */}
        <div
          className={`space-y-6 text-lg leading-relaxed ${
            dark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          <p>
            Hi! I'm a nursing student navigating the wonderfully chaotic world of healthcare
            education in Dhaka, Bangladesh. I started this site because study notes shouldn't
            cost you your sanity — or your printer ink.
          </p>

          <p>
            <strong className={dark ? "text-white" : "text-gray-900"}>What you'll find here:</strong>{" "}
            concise, well-organized nursing notes broken down by subject. No 40-page PDFs when a
            5-page one will do. The goal is clarity — because at 2am before clinicals, you need
            answers, not essays.
          </p>

          <p>
            When I'm not in class or drowning in pharmacology flashcards, I paint. Mostly
            watercolors — botanicals, soft landscapes, and the occasional dramatic sky.
            It's my antidote to the very precise world of medicine. Also potatoes. I love
            potatoes (Alu 🥔). This is relevant information.
          </p>

          <p>
            And then there's{" "}
            <strong className={dark ? "text-white" : "text-gray-900"}>Tuki</strong> 🩷 — my cat,
            my emotional support animal, and honestly the reason this site looks as good as it does.
            She has standards. I just try to keep up.
          </p>

          <p>
            I also run a YouTube channel as{" "}
            <a
              href="https://www.youtube.com/@Caffei_N"
              target="_blank"
              rel="noreferrer"
              className="font-semibold text-emerald-600 dark:text-emerald-400 hover:underline"
            >
              Caffei_N
            </a>
            , where I share notes and the occasionally unhinged study session in video form.
            Come say hello — I promise the content is more organized than my sleep schedule.
          </p>
        </div>

        {/* Social links */}
        <div
          className={`mt-14 pt-8 border-t flex flex-wrap gap-3 justify-center ${
            dark ? "border-gray-700" : "border-gray-200"
          }`}
        >
          {SOCIAL.map(({ label, href, icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium
                transition-all duration-200 hover:scale-105 hover:shadow-md
                ${dark
                  ? "bg-gray-800 text-gray-200 hover:bg-gray-700 border border-gray-700"
                  : "bg-white text-gray-700 hover:bg-emerald-50 hover:text-emerald-700 border border-gray-100 shadow-sm"
                }`}
            >
              <span className="text-xl">{icon}</span>
              {label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
